<template>
  <v-dialog
    persistent
    v-model="showDialog"
    max-width="700px"
  >
    <ApplicationMessage
      title="Meddela inblandade parter"
      :infoText="infoText"
      :defaultMessage="defaultMessage"
      @close="close"
      @send="send"
    />
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import API from '@/services/api.js'
import ApplicationMessage from '@/components/application/ApplicationMessage'

// @group Application
// ChangeStatusModal component
export default {
  name: 'ChangeStatusModal',

  components: {
    ApplicationMessage
  },

  props: {
    // Should dialog be showed
    show: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    //has status changed
    changedStatus: {
      // `Object`
      type: Object,
      required: true
    }
  },

  data: () => ({
    showDialog: false,
    items: [],
    defaultMessage: '',
    infoText: ''
  }),

  created() {
    API.listApplicationStates()
      .then(response => {
        response.data.forEach(o => {
          this.items[o.id] = o.name
        })
        //- Set message and infotext
        this.defaultMessage = `Hej! 
Status på din/er anmälan har ändrats!`
        this.infoText = `Du har ändrat status på anmälan. Vill du skicka ett meddelande till de inblandade om detta?`
      })
      .catch(error => {
        console.log('There was an error:', error)
      })
  },

  computed: {
    ...mapGetters('application', ['selectedApplication'])
  },

  watch: {
    show() {
      this.showDialog = this.show
    }
  },

  methods: {
    close() {
      // Fire close event
      // @arg called with no argument , close the modal
      this.$emit('close')
    },

    send(message) {
      // Fire send event , when form is submited
      // @arg The argument is a string representing the message
      this.$emit('send', message)
    }
  }
}
</script>

<style>
</style>